import React from 'react';
import { Card, Form, FormInstance, Tabs } from 'antd';
import { BasicInfoTab } from './DetailTabs';
import { ProjectResearch } from './ProjectResearch';
import { CustomerCare } from './CustomerCare';
import { CompetitorAnalysis } from './CompetitorAnalysis';
import { KeywordLibrary } from './KeywordLibrary';
import { SmartCopywriting } from './SmartCopywriting';
import { ListingCheck } from './ListingCheck';
import { RufusQATab } from './RufusQA';
import { SearchPerformanceAnalysisOnly } from '../../../components/SKUDetail/SearchPerformanceSection/SearchPerformanceAnalysisOnly';
import SKUSalesAnalysis from '../../../components/SKUDetail/SalesAnalysisSection/SKUSalesAnalysis';

import { SKUFormLogisticsFields } from '../../SKUManagement/SKUFormLogisticsFields';
import { SKUFormSupplierFields } from '../../SKUManagement/SKUFormSupplierFields';
import { SKUFormPricingFields } from '../../SKUManagement/SKUFormPricingFields';
import { SKUFormMediaFields } from '../../SKUManagement/SKUFormMediaFields';
import { SKUFormStrategyFields } from '../../SKUManagement/SKUFormStrategyFields';

export const getDetailTabItems = (
    skuData: any,
    form: FormInstance,
    brands: any[],
    handleCopywritingDataChange: (data: any) => void
) => {
    return [
        // 第一阶段：立项调研
        {
            key: 'research',
            label: '立项调研',
            children: <ProjectResearch skuId={skuData?.id} form={form} />,
        },
        // 第二阶段：产品开发
        {
            key: 'basic',
            label: '产品信息',
            children: <BasicInfoTab form={form} brands={brands} />,
        },
        {
            key: 'supply',
            label: '供应链',
            children: (
                <Card variant="borderless">
                    <Form form={form} layout="vertical">
                        <SKUFormSupplierFields />
                        <SKUFormLogisticsFields />
                    </Form>
                </Card>
            ),
        },
        {
            key: 'pricing',
            label: '定价分析',
            children: (
                <Card variant="borderless">
                    <Form form={form} layout="vertical">
                        {/* Hidden fields for pricing calculations */}
                        <Form.Item name="length" hidden><input /></Form.Item>
                        <Form.Item name="width" hidden><input /></Form.Item>
                        <Form.Item name="height" hidden><input /></Form.Item>
                        <Form.Item name="weight" hidden><input /></Form.Item>
                        <Form.Item name="purchase_cost_cny" hidden><input /></Form.Item>
                        <Form.Item name="category" hidden><input /></Form.Item>
                        <Form.Item name="operation_strategy_data" hidden><input /></Form.Item>
                        <SKUFormPricingFields form={form} key={skuData?.id || 'loading'} />
                    </Form>
                </Card>
            ),
        },
        {
            key: 'media',
            label: '媒体素材',
            children: (
                <Card variant="borderless">
                    <Form form={form} layout="vertical">
                        <SKUFormMediaFields />
                    </Form>
                </Card>
            ),
        },
        {
            key: 'copywriting',
            label: '智能文案',
            children: (
                <Card variant="borderless">
                    <SmartCopywriting
                        key={skuData?.id || 'loading'}
                        skuId={skuData?.id}
                        skuData={skuData}
                        onDataChange={handleCopywritingDataChange}
                    />
                </Card>
            ),
        },
        {
            key: 'listing_check',
            label: '页面完整度',
            children: (
                <Card variant="borderless">
                    <ListingCheck skuId={skuData?.id} />
                </Card>
            ),
        },
        {
            key: 'rufus',
            label: 'Rufus问答',
            children: (
                <Card variant="borderless">
                    <RufusQATab
                        skuId={skuData?.id || 0}
                        asin={skuData?.asin}
                        site={skuData?.site || 'US'}
                    />
                </Card>
            ),
        },
        // 第三阶段：运营策略
        {
            key: 'strategy',
            label: '产品策略',
            children: (
                <Card variant="borderless">
                    <Form form={form} layout="vertical">
                        <SKUFormStrategyFields skuId={skuData?.id} />
                    </Form>
                </Card>
            ),
        },
        {
            key: 'keywords',
            label: '关键词库',
            children: (
                <Card variant="borderless">
                    <KeywordLibrary skuId={skuData?.id} />
                </Card>
            ),
        },
        {
            key: 'customer_care',
            label: '客户关怀',
            children: (
                <Card variant="borderless">
                    <CustomerCare skuId={skuData?.id ?? 0} />
                </Card>
            ),
        },
        {
            key: 'competitor',
            label: '竞品分析',
            children: (
                <div style={{ padding: 16 }}>
                    <CompetitorAnalysis />
                </div>
            ),
        },
        // 第四阶段：数据监控
        {
            key: 'data',
            label: '运营数据',
            children: (
                <div style={{ padding: 16 }}>
                    <Tabs
                        type="card"
                        items={[
                            {
                                key: 'sales',
                                label: '销售分析',
                                children: (
                                    <SKUSalesAnalysis
                                        skuId={skuData?.id}
                                        sellerMappings={skuData?.seller_mappings || []}
                                        sellerSkuId={skuData?.seller_mappings?.[0]?.id} // Legacy compatibility
                                    />
                                )
                            },
                            {
                                key: 'search',
                                label: '搜索表现',
                                children: <SearchPerformanceAnalysisOnly skuId={skuData?.id} />
                            }
                        ]}
                    />
                </div>
            ),
        },
    ];
};
